module.exports = __webpack_public_path__ + "static/media/infectious.5ee1dca0.mp3";